import React, { Component } from 'react';
import { Button, Table, Tooltip, Row, Col } from 'antd';
import { connect } from 'dva';
import moment from 'moment';
import SelectModal from './select';

@connect(({ homePage }) => ({
  ...homePage,
}))
class SelectArticle extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selctVisible: false,
    };
  }

  selectArticles = () => {
    this.setState({ selctVisible: true });
  };

  closeModal = () => {
    this.setState({ selctVisible: false });
  };

  callBack = (tags, selectedRowKeys) => {
    const { dispatch, formData } = this.props;
    const { carouselModule } = formData;
    dispatch({
      type: 'homePage/saveState',
      payload: {
        customerSelectNews: tags,
        formData: {
          ...formData,
          carouselModule: {
            ...carouselModule,
            carousel: (selectedRowKeys && selectedRowKeys.join(',')) || '',
          },
        },
      },
    });
  };

  render() {
    const { selctVisible } = this.state;
    const { customerSelectNews = [] } = this.props;
    const tableHeader = [
      {
        title: '文章标题',
        dataIndex: 'title',
        render: text => {
          if (text.length <= 12) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '所属栏目',
        width: 160,
        dataIndex: 'id',
        render: (val, record) => record.channel && record.channel.title,
      },
      {
        title: '最后编辑时间',
        width: 150,
        dataIndex: 'gmtModify',
        render: val => moment(val).format('YYYY.MM.DD HH:mm'),
      },
    ];
    return (
      <Row style={{ paddingRight: 30, top: '-24px' }}>
        <Col
          xs={{ offset: 24 }}
          sm={{ offset: 24 }}
          md={{ offset: 5 }}
          lg={{ offset: 5 }}
          xl={{ offset: 5 }}
        >
          <Button onClick={this.selectArticles} style={{ marginBottom: 12, marginLeft: 6 }}>
            选择文章
          </Button>
          {!!customerSelectNews.length && (
            <Table
              columns={tableHeader}
              dataSource={customerSelectNews}
              size="middle"
              pagination={false}
              style={{ marginLeft: 6, marginBottom: 10 }}
            />
          )}
        </Col>
        {selctVisible && (
          <SelectModal
            visible={selctVisible}
            close={this.closeModal}
            number={5}
            selectNews={customerSelectNews}
            callBack={this.callBack}
          />
        )}
      </Row>
    );
  }
}
export default SelectArticle;
